/**
 * actions
 */
import { store } from './store';
import {effectActionCreator}  from './effect'
import JudgeActionExtendParam from './config/actionExtendParam'
const SEP = '/'
export const actions = {};

export function addActions(modelName,reducers={},effects={}){
    if(Object.keys(reducers).length){
        actions[modelName] = actions[modelName] || {};
    }
    each(reducers, actionName =>{
        actions[modelName][actionName] = actionCreator(modelName,actionName);
    })
    each(effects, effectName => {
        if (actions[modelName][effectName]) {
          throw new Error(`Action name "${effectName}" has been used! Please select another name as effect name!`)
        }
        if(typeof effects[effectName] === 'function'){
            // options.addEffect(`${modelName}${SEP}${effectName}`, effects[effectName])
    
        // Effect is like normal action, except it is handled by mirror middleware
        actions[modelName][effectName] = effectActionCreator(modelName, effectName,effects[effectName])
        // Allow packages to differentiate effects from actions
        actions[modelName][effectName].isEffect = true
        }else{
            console.warn(`effects filters automatically auto no-function key ${effectName}`)
        }
       
    })

 }

function each(obj, callback) {
    Object.keys(obj).forEach(callback)
}

function actionCreator(modelName,actionName){
    return ({data,extendParams}={}) =>{
        JudgeActionExtendParam(extendParams);
        store.dispatch({
            type: `${modelName}${SEP}${actionName}`,
            data,
            extendParams
        })
    }
}